import type { FactionRelationship } from '../../shared/game/factions.js';

export const darkClawFaction = { id: 'dark-claw', name: 'Dark Claw', cloth: 0xa52a2a, emblem: 'dark-claw' } as const;

export const coastFactionRelationships: FactionRelationship[] = [
  { factions: ['bandits', 'wolves'], relation: 'hostile' },
  { factions: ['party', 'dark-claw'], relation: 'hostile' },
];
